module.exports = __webpack_public_path__ + "img/mob-roadMap.9ba7caa5.svg";